"use client"

import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion"
import {
    Check,
    CircleArrowRight,
    MapPin,
} from "lucide-react"
import { useRouter } from "next/navigation"
import { Button } from "../../ui/button"

import { CircularData } from "@/types/circulars"

import fixNewsContent from "@/lib/SVG_Render"
type PositionsCardProps = CircularData & {
  onApply: () => void;
  isHome: boolean;
};

function PositionsCard({ id, title, company, content,position, location, type, deadline, onApply, isHome }: PositionsCardProps) {
    const router = useRouter();
  const handleApplyClick = () => {
    if (isHome) {
      router.push("/career");
    } else {
      onApply();
      document.getElementById("apply")?.scrollIntoView({ behavior: "smooth" });
    }
  }
  
  // Truncate the content to the first 120 characters for the initial view
  const truncatedContent = content.length > 200 ? content.slice(0, 200) + "..." : content;

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full border-t pt-6 md:pt-12"
    >
      <AccordionItem
        value={`item-${id}`}
        className="w-full group"
      >
        {/* Main Card Content */}
        <div className="space-y-4">
          {/* title & company */}
          <h1 className="text-base md:text-lg font-bold capitalize text-foreground">{title}</h1>
          <div className="md:flex items-center space-y-2 md:space-y-0 md:space-x-4">
            <h2 className="text-base font-bold capitalize text-foreground">{position.name}</h2>
            <div className="px-3 py-1 w-fit font-semibold border border-ring text-sm md:text-base text-foreground">
              <p className="text-sm">{company.name}</p>
            </div>
          </div>

          {/* description (clamped by default) */}
          <div className="text-muted-foreground mt-4 text-sm ">
            <div 
              className="prose group-data-[state=open]:hidden text-sm leading-relaxed" 
              dangerouslySetInnerHTML={{ __html: fixNewsContent(truncatedContent) }}
            ></div>
          </div>
          
          <AccordionContent>
            <div
              className="prose text-muted-foreground text-sm leading-relaxed"
              dangerouslySetInnerHTML={{ __html: fixNewsContent(content) }}
            ></div>
          </AccordionContent>
          
          {/* footer row with buttons */}
          <div className="">
            {/* location */}
            <div className="flex flex-wrap md:flex-row items-center">
              <div className="px-3 py-1 flex items-center space-x-2 border border-ring ">
                <MapPin className="size-4" />
                <p className="text-sm ">{location}</p>
              </div>
              {/* time */}
              <div className="px-3 py-1 flex items-center space-x-2 border border-ring">
                <Check className="size-4" />
                <p className="text-sm s">{type.label}</p>
              </div>
              {/* deadline */}
              <div className="px-3 py-1 border border-ring">
                <p className="text-sm ">Deadline: {deadline}</p>
              </div>
            </div>
            {/* button area */}
            <div className="flex items-center gap-4">
                <Button
                  onClick={handleApplyClick}
                  className="rounded-full bg-primary hover:bg-prime-hover cursor-pointer flex items-center my-2"
                >
                  <CircleArrowRight className="size-4" />
                  <span className="text-sm ">Apply now</span>
                </Button>

                {/* accordion trigger */}
                {content.length > 200 && (
                  <AccordionTrigger className="text-primary hover:text-prime-hover cursor-pointer">
                    <span className="group-data-[state=open]:hidden">See Details</span>
                    <span className="hidden group-data-[state=open]:inline">Hide Details</span>
                  </AccordionTrigger>
                )}
            </div>
           
          </div>
        </div>
      </AccordionItem>
    </Accordion>
  )
}

export default PositionsCard